import React, { useState } from "react";

function ContactForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [submitStatus, setSubmitStatus] = useState("idle");

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "61ac2440-d3be-4d27-9f76-cd0927f96f73");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      setSubmitStatus("success");
      setName("");
      setEmail("");
      setMessage("");
    } else {
      setSubmitStatus("error");
    }
  };

  return (
    <div className="contact-form row justify-content-center">
      <div className="col-lg-8">
        <form onSubmit={onSubmit}>
          <div className="mb-24">
            <label htmlFor="name" className="d-block mb-16">
              Nafn
            </label>
            <input
              id="name"
              name="name" 
              type="text"
              className="w-100 border-0"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="mb-24">
            <label htmlFor="email" className="d-block mb-16">
              Netfang
            </label>
            <input
              id="email"
              name="email"
              type="email"
              className="w-100 border-0"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="mb-24">
            <label htmlFor="message" className="d-block mb-16">
              Skilaboð
            </label>
            <textarea
              id="message"
              name="message"
              className="w-100 border-0"
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn-default border-0">
            Senda
          </button>
        {submitStatus === "success" && (
          <div className="alert alert-success font-stabil">
            Takk fyrir póstinn! Við munum svara fyrirspurninni eins fljótt og auðið er.
          </div>
        )}

        {submitStatus === "error" && (
          <div className="alert alert-danger font-stabil mt-4">
            Villa kom upp. Vinsamlegast reyndu aftur síðar.
          </div>
        )}
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
